import { render, staticRenderFns } from "./UploadProfilePhoto.vue?vue&type=template&id=156314eb&"
import script from "./UploadProfilePhoto.vue?vue&type=script&lang=js&"
export * from "./UploadProfilePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports